import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import { restActionFactory } from "../../toolkit/axiosActions/axiosActionsFactory";
import constants from "../../utils/constants";

const PERSONA_REFERENCIA_BASE_URL = "/api/persona-referencia";

const personaReferenciaRestAction = restActionFactory(
  `${constants.BASE_URL}${PERSONA_REFERENCIA_BASE_URL}`
);

export const getControversiaCurp = (
  idPersonaCurp: number,
  idPersonaSolicitante?: number
): IAction => {
  const params = idPersonaSolicitante
    ? `?idPersonaSolicitante=${idPersonaSolicitante}`
    : "";
  return personaReferenciaRestAction({
    actionType: actionTypes.GET_CONTROVERSIA_CURP,
    urlComplement: `/controversia-curp/${idPersonaCurp}${params}`,
    method: "get"
  });
};

export const putLiberarCurp = (
  idPersona: number,
  idPersonaSolicitante?: number
): IAction => {
  const params = idPersonaSolicitante
    ? `?idPersonaSolicitante=${idPersonaSolicitante}`
    : "";
  return personaReferenciaRestAction({
    actionType: actionTypes.PUT_LIBERAR_CURP,
    urlComplement: `/liberar-curp/${idPersona}${params}`,
    method: "put"
  });
};

export const putHomologarPropietario = (
  idMembresiaSocio: number,
  curp: string
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.PUT_HOMOLOGAR_PROPIETARIO,
    urlComplement: `/homologar-propietario?idMembresiaSocio=${idMembresiaSocio}&curp=${curp}`,
    method: "put"
  });
};

export const putHomologarTitularMayor = (
  idMembresiaSocio: number,
  idTitular: number
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.PUT_HOMOLOGAR_TITULAR_MAYOR,
    urlComplement: `/homologar-titular-mayor?idMembresiaSocio=${idMembresiaSocio}&idTitular=${idTitular}`,
    method: "put"
  });
};

export const postVerificarExtranjero = (
  idPersona: number,
  idStorage: number,
  idMembresiaSocio?: number
): IAction => {
  const params = idMembresiaSocio
    ? `?idMembresiaSocio=${idMembresiaSocio}`
    : "";
  return personaReferenciaRestAction({
    actionType: actionTypes.POST_VERIFICAR_EXTRANJERO,
    urlComplement: `/verificar-extranjero/${idPersona}/${idStorage}${params}`,
    method: "post"
  });
};

export const postVerificarDocumentoTitular = (
  idMembresiaSocio: number
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.POST_VERIFICAR_DOCUMENTO_TITULAR,
    urlComplement: `/verificar-documento-titular/${idMembresiaSocio}`,
    method: "post"
  });
};

export const postVerificarDocumentoIntegrante = (
  idMembresiaSocioPersona: number
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.POST_VERIFICAR_DOCUMENTO_INTEGRANTE,
    urlComplement: `/verificar-documento-integrante/${idMembresiaSocioPersona}`,
    method: "post"
  });
};

export const getVerificarPropietarioDuplicado = (
  idPropietario: number,
  curp: string
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.GET_VERIFICAR_PROPIETARIO_DUPLICADO,
    urlComplement: `/verificar-propietario-duplicado?idPropietario=${idPropietario}&curp=${curp}`,
    method: "get"
  });
};

export const getIdentificacionTitularExtranjero = (
  idMembresiaSocio: number
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.GET_IDENTIFICACION_TITULAR_EXTRANJERO,
    urlComplement: `/identificacion-titular-extranjero/${idMembresiaSocio}`,
    method: "get"
  });
};

export const getIdentificacionIntegranteExtranjero = (
  idMembresiaSocioPersona: number
): IAction => {
  return personaReferenciaRestAction({
    actionType: actionTypes.GET_IDENTIFICACION_INTEGRANTE_EXTRANJERO,
    urlComplement: `/identificacion-integrante-extranjero/${idMembresiaSocioPersona}`,
    method: "get"
  });
};

export const clearPersonaReferencia = (): IAction => {
  return {
    type: actionTypes.CLEAR_PERSONA_REFERENCIA
  };
};
